import Vue from 'vue';
import Vuex from 'vuex';
import cloneDeep from 'lodash.clonedeep';
import api from '../api/';

Vue.use(Vuex);

export default new Vuex.Store({
    // State is not being handled completely correctly. This will yell at you.
    strict: process.env.NODE_ENV !== 'production',
    state: {
        averages: null,
        listedResults: null,
        status: 'selection', // selection, results
        selectedTab: 'filters', // filters, companies
        ids: [],
        searchTerm: '',
        selectedAsset: {},
        selectedRegionTab: 'a',
        selectedCurrency: '',
        currentPage: 1,
        sort: {
            type: 'mkt_cap',
            dir: 'desc'
        },
        marketDataPrices: new Map(),
        currencyConversions: new Map(),
        previousAssets: null, // Handle instance where user changes assets & no results.
        groups: [],
        regions: [
            { name: 'canada', selected: false, region: "na"},
            { name: 'mexico', selected: false, region: "na"},
            { name: 'united_states', selected: false, region: "na"},
            { name: 'argentina', selected: false, region: "sa"},
            { name: 'brazil', selected: false, region: "sa"},
            { name: 'chile', selected: false, region: "sa"},
            { name: 'colombia', selected: false, region: "sa"},
            { name: 'ecuador', selected: false, region: "sa"},
            { name: 'guyana', selected: false, region: "sa"},
            { name: 'paraguay', selected: false, region: "sa"},
            { name: 'peru', selected: false, region: "sa"},
            { name: 'suriname', selected: false, region: "sa"},
            { name: 'uruguay', selected: false, region: "sa"},
            { name: 'austria', selected: false, region: "eu"},
            { name: 'belgium', selected: false, region: "eu"},
            { name: 'bulgaria', selected: false, region: "eu"},
            { name: 'croatia', selected: false, region: "eu"},
            { name: 'czech_republic', selected: false, region: "eu"},
            { name: 'estonia', selected: false, region: "eu"},
            { name: 'finland', selected: false, region: "eu"},
            { name: 'france', selected: false, region: "eu"},
            { name: 'germany', selected: false, region: "eu"},
            { name: 'hungary', selected: false, region: "eu"},
            { name: 'ireland', selected: false, region: "eu"},
            { name: 'israel', selected: false, region: "eu"},
            { name: 'italy', selected: false, region: "eu"},
            { name: 'latvia', selected: false, region: "eu"},
            { name: 'lithuania', selected: false, region: "eu"},
            { name: 'luxembourg', selected: false, region: "eu"},
            { name: 'netherlands', selected: false, region: "eu"},
            { name: 'norway', selected: false, region: "eu"},
            { name: 'poland', selected: false, region: "eu"},
            { name: 'portugal', selected: false, region: "eu"},
            { name: 'romania', selected: false, region: "eu"},
            { name: 'spain', selected: false, region: "eu"},
            { name: 'slovakia', selected: false, region: "eu"},
            { name: 'sweden', selected: false, region: "eu"},
            { name: 'switzerland', selected: false, region: "eu"},
            { name: 'united_kingdom', selected: false, region: "eu"},
            { name: 'hong_kong', selected: false, region: "ap"},
            { name: 'japan', selected: false, region: "ap"},
            { name: 'macao', selected: false, region: "ap"},
            { name: 'singapore', selected: false, region: "ap"},
            { name: 'egypt', selected: false, region: "af"},
            { name: 'ghana', selected: false, region: "af"},
            { name: 'morocco', selected: false, region: "af"},
            { name: 'nigeria', selected: false, region: "af"},
            { name: 'south_africa', selected: false, region: "af"},
            { name: 'australia', selected: false, region: "oc"},
            { name: 'new_zealand', selected: false, region: "oc"},
            { name: 'papua_new_guinea', selected: false, region: "oc"},
        ],
        sectors: [
            { name: "basic_materials", selected: false },
            { name: "consumer_cyclicals", selected: false },
            { name: "consumer_noncyclicals", selected: false },
            { name: "energy", selected: false },
            { name: "financials", selected: false },
            { name: "healthcare", selected: false },
            { name: "industrials", selected: false },
            { name: "real_estate", selected: false },
            { name: "technology", selected: false },
            { name: "utilities", selected: false },
            { name: "mixed", selected: false, disabled: true }
            ],
        marketCaps: [
            { name: "mega_cap", selected: false },
            { name: "large_cap", selected: false },
            { name: "mid_cap", selected: false },
            { name: "small_cap", selected: false },
            { name: "micro_cap", selected: false }
        ],
        assets: [
            { name: 'stocks', selected: false }, // Default
            { name: 'etfs', selected: false },
        ],
        currencies: [
            { name: "select_usd", value: 'USD' },
            { name: "select_aud", value: 'AUD' },
            { name: "select_brl", value: 'BRL' },
            { name: "select_gbp", value: 'GBP' },
            { name: "select_bgn", value: 'BGN' },
            { name: "select_cad", value: 'CAD' },
            { name: "select_cnh", value: 'CNH' },
            { name: "select_cny", value: 'CNY' },
            { name: "select_hrk", value: 'HRK' },
            { name: "select_czk", value: 'CZK' },
            { name: "select_dkk", value: 'DKK' },
            { name: "select_eur", value: 'EUR' },
            { name: "select_hkd", value: 'HKD' },
            { name: "select_huf", value: 'HUF' },
            { name: "select_inr", value: 'INR' },
            { name: "select_ils", value: 'ILS' },
            { name: "select_jpy", value: 'JPY' },
            { name: "select_mxn", value: 'MXN' },
            { name: "select_nok", value: 'NOK' },
            { name: "select_nzd", value: 'NZD' },
            { name: "select_pln", value: 'PLN' },
            { name: "select_ron", value: 'RON' },
            { name: "select_sar", value: 'SAR' },
            { name: "select_sgd", value: 'SGD' },
            { name: "select_krw", value: 'KRW' },
            { name: "select_sek", value: 'SEK' },
            { name: "select_chf", value: 'CHF' },
            { name: "select_zar", value: 'ZAR' },
            { name: "select_twd", value: 'TWD' },
            { name: "select_try", value: 'TRY' },
            { name: "select_uae", value: 'AED' }
        ],
        filterButtons: true
    },
    mutations: {
        setSelectedTab(state, value) {
            state.selectedTab = value;
        },
        resetGroups(state) {
            state.groups = [];
        },
        deleteGroup(state, index) {
            state.groups.splice(index, 1);
        },
        updateGroup(state, payload) {
            const updated = {
                companies: payload.companies
            }
            Vue.set(state.groups, payload.index, updated);
        },
        toggleCompanySelection(state, payload) {
            const index = payload.index;
            const id = payload.id;
            const companies = state.groups[index].companies;
            for (let i = 0; i < companies.length; i++) {
                if (companies[i].id === id) {
                    companies[i].selected = !companies[i].selected;
                    break;
                }
            }
        },
        setRegion(state, {index, region}) {
            Vue.set(state.regions, index, region);
        },
        setRegions(state, regions) {
            state.regions = regions;
        },
        setAssets(state, assets) {
            state.assets = assets;
        },
        setSector(state, {index, sector}) {
            Vue.set(state.sectors, index, sector);
        },
        setSectors(state, sectors) {
            state.sectors = sectors;
        },
        setMarketCap(state, {index, marketCap}) {
            Vue.set(state.marketCaps, index, marketCap);
        },
        setMarketCaps(state, marketCaps) {
            state.marketCaps = marketCaps;
        },
        setSelectedCurrency(state, currency) {
            state.selectedCurrency = currency;
        },
        setStatus(state, status) {
            state.status = status;
        },
        setSelectedRegionTab(state, tab) {
            state.selectedRegionTab = tab;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        },
        setSorting(state, sort) {
            state.sort = sort;
        },
        setPreviousAssets(state, asset) {
            state.previousAssets = asset;
        },
        setIds(state, ids) {
            state.ids = ids;
        },
        hideFilters(state) {
            state.filterButtons = !state.filterButtons;
        },
        setAverages(state, averages) {
            state.averages = averages;
        },
        setListedResults(state, results) {
            state.listedResults = results;
        },
        appendListedResults(state, results) {
            const updated = cloneDeep(state.listedResults);
            updated.res = [].concat(updated.res, results.res);
            updated.total = results.total;
            state.listedResults = updated;
        }
    },
    actions: {
        setSelectedTab({commit}, value) {
            commit('setSelectedTab', value);
        },

        resetGroups({commit}) {
            commit('resetGroups');
        },
        updateGroup({commit}, {index, companies}) {
            commit('updateGroup', {index, companies});
        },
        deleteGroup({commit}, index) {
            commit('deleteGroup', index);
        },
        toggleCompanySelection({commit}, {index, id}) {
            commit('toggleCompanySelection', {
                index,
                id
            });
        },
        setRegion({commit}, {region, index}) {
            commit('setRegion', {region, index});
        },
        setRegions({commit}, regions) {
            commit('setRegions', regions);
        },
        setAssets({commit, state}, assets) {
            commit('setPreviousAssets', state.assets);
            commit('setAssets', assets);
            commit('setSorting', {
                type: 'mkt_cap',
                dir: 'desc'
            });

            // If ETF was chosen first and then switched to stocks, no market cap was set, enable all market caps in such a case.
            if (state.status === 'results' && state.marketCaps.filter(mkt => mkt.selected).length < 1 && assets.find(item => item.name === 'stocks').selected) {
                const marketCaps = cloneDeep(state.marketCaps);
                marketCaps.forEach(mktCap => mktCap.selected = true);
                commit('setMarketCaps', marketCaps);
            }

            // Mixed should be disabled if user only has stocks chosen & enabled if etfs/all chosen
            const mixedSector = cloneDeep(state.sectors.find(item => item.name === 'mixed'));
            const mixedDisabled = mixedSector.disabled;
            if (assets.find(item => item.name === 'etfs').selected && mixedDisabled) {
                const index = state.sectors.findIndex(item => item.name === 'mixed');
                mixedSector.disabled = false;
                commit('setSector', {index, sector: mixedSector});
            }
            else if (assets.find(item => item.name === 'stocks').selected && !assets.find(item => item.name === 'etfs').selected && !mixedDisabled) {
                const index = state.sectors.findIndex(item => item.name === 'mixed');
                mixedSector.disabled = true;
                commit('setSector', {index, sector: mixedSector});
            }
        },
        setSector({commit}, {index, sector}) {
            commit('setSector', {index, sector});
        },
        setSectors({commit}, sectors) {
            commit('setSectors', sectors);
        },
        setMarketCap({commit}, {index, marketCap}) {
            commit('setMarketCap', {index, marketCap});
        },
        setMarketCaps({commit}, marketCaps) {
            commit('setMarketCaps', marketCaps);
        },
        setSelectedCurrency({commit}, currency) {
            commit('setSelectedCurrency', currency);
        },
        setStatus({commit}, status) {
            commit('setStatus', status);
        },
        setSelectedRegionTab({commit}, tab) {
            commit('setSelectedRegionTab', tab);
        },
        setCurrentPage({commit}, page) {
            commit('setCurrentPage', page);
        },
        setSorting({commit}, sort) {
            commit('setSorting', sort);
        },
        reset({commit, state}) {
            commit('setStatus', 'selection');
            commit('setSelectedRegionTab', 'a');
            commit('resetGroups');
            commit('setSelectedCurrency', '');
            commit('setIds', []);
            commit('setCurrentPage', 1);

            const newRegions = cloneDeep(state.regions);
            newRegions.forEach(item => item.selected = false);
            commit('setRegions', newRegions);

            const newAssets = cloneDeep(state.assets);
            newAssets.forEach(item => item.selected = false);
            commit('setAssets', newAssets);

            const sectors = cloneDeep(state.sectors);
            sectors.forEach(item => item.selected = false);
            commit('setSectors', sectors);

            const marketCaps = cloneDeep(state.marketCaps);
            marketCaps.forEach(item => item.selected = false);
            commit('setMarketCaps', marketCaps);
        },
        rollbackAssets({commit, state}) {
            if (!state.previousAssets) return;
            commit('setAssets', state.previousAssets);
        },
        setIds({commit}, ids) {
            commit('setIds', ids);
        },
        hideFilters({commit}) {
            commit('hideFilters');
        },
        search({state, dispatch, getters}, {skipAvg = false, firstCall = false}) {
            console.debug({firstCall});
            if(state.selectedTab === 'companies'){
                let assets = [];
                for(let i = 0; i < state.groups.length; i++){
                    for(let j = 0; j < state.groups[i].companies.length; j++){
                        assets.push(state.groups[i].companies[j].type);
                    }
                }
                let stockFlag = assets.includes('stocks');
                let etfFlag = assets.includes('etfs');
                let multipleAssets = stockFlag && etfFlag;
                if (state.selectedTab === 'companies' && (stockFlag === true && etfFlag === false)) {
                    console.debug('Group Search');
                    return dispatch('searchGroups');
                } else if(state.selectedTab === 'companies' && (etfFlag === true && stockFlag === false)){
                    console.debug('Search ETF NEW');
                    return dispatch('searchETF', { skipAvg, firstCall });
                } else if(state.selectedTab === 'companies' && multipleAssets === true){
                    console.debug('Search both Stock and ETF');
                    return dispatch('searchStockETF', {skipAvg, firstCall});
                }
            }
            
            
            const chosenAsset = getters.selectedAssetsTerm;
            console.log('Chosen asset is:   ',chosenAsset); 

            if (state.ids.length > 0) {
                return dispatch('searchIds', chosenAsset);
            }

            if (!chosenAsset) {
                console.error('No asset chosen, but getResults called.');
            }
            else if(chosenAsset === 'all') {
                console.debug('Search All');
                return dispatch('searchAll', {skipAvg, firstCall});
            }
            else if(chosenAsset === 'etfs') {
                console.debug('Search ETF');
                return dispatch('searchETFs', {skipAvg, firstCall});
            }
            else if (chosenAsset === 'stocks') {
                console.debug('Search Stocks');
                return dispatch('searchStocks', {skipAvg, firstCall});
            }
        },
        searchStocks({commit, dispatch, getters, state}, { skipAvg, firstCall }) {
            return new Promise((resolve, reject) => {
                let {type, dir} = state.sort;
                if (type == 'etf_name') {
                    type = 'mkt_cap';
                    dir = 'desc';
                }

                let countries = state.regions.filter(s => s.selected).map(s => {
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let industries = state.sectors.filter(s => s.selected).map(s => {
                    if (s.name === 'consumer_noncyclicals') return 'Consumer Non-Cyclicals';
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let filters = {
                    industries,
                    countries,
                    marketcap: getters.selectedMarketCaps,
                    currency: state.selectedCurrency,
                    page: state.currentPage,
                    type: type,
                    dir: dir,
                };

                let results = {};
                if (!firstCall) { 
                    console.debug('First call is false...', firstCall);
                    commit('setStatus', 'loading');
                }

                api.searchByInd(filters)
                    .then(response => {
                        results.list = response;
                        console.debug(skipAvg, 'skipAvg');
                        if (!skipAvg) {
                            // We can do these network requests together to be faster since they don't depend on eachother
                            return Promise.all([dispatch('getExchangeRates', response), api.getWeightedSums(filters, 'stock')]);
                        }
                        return dispatch('getExchangeRates', response)
                    })
                    .then(response => {
                        if (!skipAvg) {
                            results.avg = response[1]; // API call is weird and returns a array.
                            commit('setAverages', results.avg);
                        }
                        if (state.currentPage > 1) {
                            commit('appendListedResults', results.list);
                        } else {
                            commit('setListedResults', results.list);
                        }
                        if (!firstCall) commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        // Set Error action or something to dispatch here
                        console.error('Error from API!', {error});
                        if (!firstCall) commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
        searchETFs({commit, dispatch, getters, state}, { skipAvg, firstCall }) {
            return new Promise((resolve, reject) => {
                let {type, dir} = state.sort;

                if (type == 'company' || type == 'ev' || type == 'rev' || type == 'earnings') {
                    type = 'mkt_cap';
                    dir = 'desc';
                }

                let countries = state.regions.filter(s => s.selected).map(s => {
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let industries = state.sectors.filter(s => s.selected).map(s => {
                    if (s.name === 'consumer_noncyclicals') return 'Consumer Non-Cyclicals';
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let filters = {
                    industries, 
                    countries,
                    currency: state.selectedCurrency,
                    page: state.currentPage,
                    type: type,
                    dir: dir,
                };

                let results = {};
                console.debug({firstCall});
                console.debug('Doing first call...');
                if (!firstCall) commit('setStatus', 'loading');
                api.searchETFs(filters)
                    .then(response => {
                        results.list = response;
                        if (!skipAvg) {
                            // We can do these network requests together to be faster since they don't depend on eachother
                            return Promise.all([dispatch('getExchangeRates', response), api.getWeightedSums(filters, 'ETF')]);
                        }
                        return dispatch('getExchangeRates', response)
                    })
                    .then(response => {
                        if (!skipAvg) {
                            results.avg = response[1]; // API call is weird and returns a array.
                            commit('setAverages', results.avg);
                        }
                        if (state.currentPage > 1) {
                            commit('appendListedResults', results.list);
                        } else {
                            commit('setListedResults', results.list);
                        }
                        if (!firstCall) commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        console.error('Error from API!', {error});
                        if (!firstCall) commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
        searchAll({commit, dispatch, getters, state}, { skipAvg, firstCall }) {
            return new Promise((resolve, reject) => {
                let {type, dir} = state.sort;

                if (type === 'mkt_cap') {
                    type = 'mkt_nav';
                }

                let countries = state.regions.filter(s => s.selected).map(s => {
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let industries = state.sectors.filter(s => s.selected).map(s => {
                    if (s.name === 'consumer_noncyclicals') return 'Consumer Non-Cyclicals';
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let filters = {
                    industries,
                    countries,
                    marketcap: getters.selectedMarketCaps,
                    currency: state.selectedCurrency,
                    page: state.currentPage,
                    type,
                    dir,
                };

                let results = {};
                if (!firstCall) commit('setStatus', 'loading');
                api.searchAll(filters)
                    .then(response => {
                        results.list = response;
                        if (!skipAvg) {
                            // We can do these network requests together to be faster since they don't depend on eachother
                            return Promise.all([dispatch('getExchangeRates', response), api.getWeightedSums(filters, 'all')]);
                        }
                        return dispatch('getExchangeRates', response)
                    })
                    .then(response => {
                        if (!skipAvg) {
                            results.avg = response[1]; // API call is weird and returns a array.
                            commit('setAverages', results.avg);
                        }
                        if (state.currentPage > 1) {
                            commit('appendListedResults', results.list);
                        } else {
                            commit('setListedResults', results.list);
                        }
                        if (!firstCall) commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        console.error('Error from API!', {error});
                        if (!firstCall) commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
        searchGroups({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                // A selected company is one that is checked in the UI.
                let selectedCompanies = [];
                state.groups.forEach(group => {
                    let companyIds = group.companies.filter(company => company.selected).map(company => company = company.id);
                    selectedCompanies.push.apply(selectedCompanies, companyIds);
                });
                /*
                    * We search using their conids rather than ticker/name because
                    * the final result pulls from multiple exchanges (ticker collisions).
                */
                const ids = selectedCompanies.join();

                const {type, dir} = state.sort;

                if (type == 'etf_name') {
                    type = 'mkt_cap';
                    dir = 'desc';
                }

                let results = {};
                api.searchByCompanyIds({ids, type, dir, curr: state.selectedCurrency})
                    .then(response => {
                        results = response;
                        return dispatch('getExchangeRates', response);
                    })
                    .then(() => {
                        commit('setListedResults', results);
                        resolve(results);
                    })
                    .catch(error => {
                        // Set Error State here. UI will display dialog with error msg from state var "error"
                        console.error('Error from API!', {error});
                        reject(error);
                    });
            });
        },
        searchIds({commit, dispatch, getters, state}, ticker) {
            return new Promise((resolve, reject) => {
                let results = {};

                let countries = state.regions.filter(s => s.selected).map(s => {
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                let industries = state.sectors.filter(s => s.selected).map(s => {
                    if (s.name === 'consumer_noncyclicals') return 'Consumer Non-Cyclicals';
                    const split = s.name.split("_");
                    return split.map(word => word[0].toUpperCase() + word.substr(1)).join(" ");
                }).join();

                const filters = {
                    industries,
                    countries,
                    marketcap: getters.selectedMarketCaps,
                    page: 1
                }

                commit('setStatus', 'loading');
                api.getSearchTerm(filters, state.ids, getters.selectedAssetsTerm, state.selectedCurrency, ticker)
                    .then(response => {
                        results = response;

                        const ifNullAssign = (a,b) => {
                            if (!a) return b;
                            return a;
                        }

                        // API returns different fields names depending on whether stock/etf
                        // Also just general inconsistency.
                        results.res.forEach(item => {
                            item.etf_name = ifNullAssign(item.etf_name,item.company);
                            item.country = ifNullAssign(item.country,item.company_cntry);
                            item.conv_mkt_cap_nav = ifNullAssign(item.conv_mkt_cap_nav, item.conv_mkt_cap);
                            item.div_yield = ifNullAssign(item.div_yield,item.divyield);
                            item.sector = ifNullAssign(item.sector,item.industry);
                            item.pe_ratio = ifNullAssign(item.pe_ratio,item.peexclxor);
                            item.eps_1y = ifNullAssign(item.eps_1y,item.epsgrpct);
                            item.name = ifNullAssign(item.name,item.company);
                            item.mkt_nav = ifNullAssign(item.mkt_nav,item.conv_mkt_cap_nav);
                            item.ev = ifNullAssign(item.ev,item.ev_cur);
                            item.pe = ifNullAssign(item.pe,item.pe_ratio);
                            item.rev = ifNullAssign(item.rev,item.ttmrev);
                            if (!item.earnings) {
                                item.earnings = null;
                            }
                        });

                        commit('setListedResults', results);
                        commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        console.error('Error from API!', {error});
                        commit('setIds', []);
                        commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
        getExchangeRates({commit, state}, response) {
            return new Promise((resolve) => {
                const finalCurrency = response.currency;
                const results = response.res;
                let currencies = [];
                
                results.forEach(result => {
                    if (result.orig_currency === finalCurrency) return;
                    if (currencies.indexOf(result.orig_currency) === -1) {
                        currencies.push(result.orig_currency);
                    }
                });

                if (currencies.length < 1) {
                    resolve();
                    return;
                }

                api.getExchRate(currencies.join(','), finalCurrency)
                    .then(resp => {
                        resp.res.forEach(result => {
                            const f = result.from_currency || result.from_curreny; // Typo from the backend that sometimes occurs
                            const n = result.to_currency;
                            const r = result.rate;
                            state.currencyConversions.set(f + '+' + n, r);
                        });
                        resolve();
                    });
            });
        },
        searchETF({commit, dispatch, state}, { skipAvg, firstCall }) {
            return new Promise((resolve, reject) => {
                // A selected company is one that is checked in the UI.
                let selectedCompanies = [];
                state.groups.forEach(group => {
                    let companyIds = group.companies.filter(company => company.selected).map(company => company = company.id);
                    selectedCompanies.push.apply(selectedCompanies, companyIds);
                });
                /*
                    * We search using their conids rather than ticker/name because
                    * the final result pulls from multiple exchanges (ticker collisions).
                */
                const ids = selectedCompanies.join();

                const {type, dir} = state.sort;

                if (type == 'etf_name') {
                    type = 'mkt_cap';
                    dir = 'desc';
                }
                
                let filters = {
                    ids: ids,
                    currency: state.selectedCurrency,
                    page: state.currentPage,
                    type: type,
                    dir: dir,
                };

                let results = {};
                api.searchByETFIds({ids, type, dir, curr: state.selectedCurrency, asset: 'ETF'})
                    .then(response => {
                        results.list = response;
                        if (!skipAvg) {
                            // We can do these network requests together to be faster since they don't depend on eachother
                            return Promise.all([dispatch('getExchangeRates', response), api.getWeightedSums(filters, 'ETF')]);
                        }
                        return dispatch('getExchangeRates', response)
                    })
                    .then(response => {
                        if (!skipAvg) {
                            results.avg = response[1]; // API call is weird and returns a array.
                            commit('setAverages', results.avg);
                        }
                        if (state.currentPage > 1) {
                            commit('appendListedResults', results.list);
                        } else {
                            commit('setListedResults', results.list);
                        }
                        if (!firstCall) commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        console.error('Error from API!', {error});
                        if (!firstCall) commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
        searchStockETF({commit, dispatch, getters, state}, { skipAvg, firstCall }) {
            return new Promise((resolve, reject) => {
                let selectedStockIds = [];
                let selectedETFIds = [];
                state.groups.forEach(group => {
                    let companyIds = group.companies.filter(company => company.type === 'stocks').map(company => company = company.id);
                    selectedStockIds.push.apply(selectedStockIds, companyIds);
                    let etfIds = group.companies.filter(company => company.type === 'etfs').map(company => company = company.id);
                    selectedETFIds.push.apply(selectedETFIds, etfIds);
                });
                /*
                    * We search using their conids rather than ticker/name because
                    * the final result pulls from multiple exchanges (ticker collisions).
                */
                const stockIds = selectedStockIds.join();
                const etfIds = selectedETFIds.join();
                let {type, dir} = state.sort;
    
                if (type == 'etf_name') {
                    type = 'mkt_cap';
                    dir = 'desc';
                }

                let filters = {
                    stockIds: stockIds,
                    etfIds: etfIds,
                    marketcap: getters.selectedMarketCaps,
                    currency: state.selectedCurrency,
                    page: state.currentPage,
                    type,
                    dir,
                };

                let results = {};
                api.searchStockETFS(filters)
                    .then(response => {
                        results.list = response;
                        if (!skipAvg) {
                            // We can do these network requests together to be faster since they don't depend on eachother
                            return Promise.all([dispatch('getExchangeRates', response), api.getWeightedSums(filters, 'all')]);
                        }
                        return dispatch('getExchangeRates', response)
                    })
                    .then(response => {
                        if (!skipAvg) {
                            results.avg = response[1]; // API call is weird and returns a array.
                            commit('setAverages', results.avg);
                        }
                        if (state.currentPage > 1) {
                            commit('appendListedResults', results.list);
                        } else {
                            commit('setListedResults', results.list);
                        }
                        if (!firstCall) commit('setStatus', 'results');
                        resolve(results);
                    })
                    .catch(error => {
                        console.error('Error from API!', {error});
                        if (!firstCall) commit('setStatus', 'results');
                        reject(error);
                    });
            });
        },
    },
    getters: {
        selectedRegions(state) {
            return state.regions.filter(item => item.selected).map(item => item.name);
        },
        selectedAssets(state) {
            return state.assets.filter(item => item.selected).map(item => item.name);
        },
        selectedAssetsTerm(state, getters) {
            if (getters.selectedAssets.length === 2) return 'all';
            if (getters.selectedAssets[0] === 'etfs') return 'etfs';
            if (getters.selectedAssets[0] === 'stocks') return 'stocks';
        },
        selectedSectors(state) {
            return state.sectors.filter(item => item.selected);
        },
        selectedMarketCaps(state) {
            return state.marketCaps.filter(item => item.selected).map(item => item.name);
        }
    }
});
